document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('form-register');
    if (!form) return;

    var email = document.getElementById('email');
    var emailConfirm = document.getElementById('email-confirm');
    if (!email || !emailConfirm) return;

    var INVALID_CLASS = 'is-invalid';
    var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

    var emailErrorEl = document.querySelector('.js-email-error strong');
    var emailConfirmErrorEl = document.querySelector('.js-email-confirm-error strong');

    var messages = {
        invalidFormat: (window.registerMessages || {}).invalidFormat || 'Invalid email format.',
        mismatch: (window.registerMessages || {}).mismatch || 'Emails do not match.'
    };

    var emailValid = !email.classList.contains(INVALID_CLASS);
    var confirmValid = !emailConfirm.classList.contains(INVALID_CLASS);

    function setState(input, errorEl, valid, message) {
        if (valid) {
            input.classList.remove(INVALID_CLASS);
            if (errorEl) errorEl.textContent = '';
        } else {
            input.classList.add(INVALID_CLASS);
            if (errorEl) errorEl.textContent = message;
        }
    }

    function validateEmail() {
        var value = email.value.trim();
        if (value === '') {
            emailValid = true;
            return setState(email, emailErrorEl, true);
        }
        emailValid = EMAIL_REGEX.test(value);
        setState(email, emailErrorEl, emailValid, messages.invalidFormat);
    }

    function validateConfirm() {
        var value = emailConfirm.value.trim();
        if (value === '') {
            confirmValid = true;
            return setState(emailConfirm, emailConfirmErrorEl, true);
        }
        if (value !== email.value.trim()) {
            confirmValid = false;
            return setState(emailConfirm, emailConfirmErrorEl, false, messages.mismatch);
        }
        confirmValid = EMAIL_REGEX.test(value);
        setState(emailConfirm, emailConfirmErrorEl, confirmValid, messages.invalidFormat);
    }

    email.addEventListener('blur', validateEmail);
    email.addEventListener('input', function () {
        if (!emailValid) validateEmail();
        if (!confirmValid) validateConfirm();
    });
    emailConfirm.addEventListener('blur', validateConfirm);
    emailConfirm.addEventListener('input', function () {
        if (!confirmValid) validateConfirm();
    });

    form.addEventListener('submit', function (e) {
        validateEmail();
        validateConfirm();
        if (!emailValid || !confirmValid) {
            e.preventDefault();
            (!emailValid ? email : emailConfirm).focus();
        }
    });
});